/* BilingualHeading – language-aware renderer.
   Shows EN when lang === "en" and HU when lang === "hu".
   Falls back to EN if HU is missing. */
import { useLanguage } from "@/contexts/LanguageContext";

function pick(en, hu, lang) {
  if (lang === "hu" && hu) return hu;
  return en;
}

export function BilingualEyebrow({ en, hu, className = "" }) {
  const { lang } = useLanguage();
  const text = pick(en, hu, lang);
  return (
    <p className={`text-[11px] uppercase tracking-[0.2em] font-mono font-medium mb-4 ${className}`}>
      {text}
    </p>
  );
}

export function BilingualHeading({ en, hu, className = "", colorClass = "" }) {
  const { lang } = useLanguage();
  const text = pick(en, hu, lang);
  return (
    <div className={className}>
      <h2 className={`font-heading text-4xl md:text-5xl font-bold tracking-tight leading-tight ${colorClass}`}>
        {text}
      </h2>
    </div>
  );
}

export function BilingualSubheading({ en, hu, className = "", colorClass = "" }) {
  const { lang } = useLanguage();
  const text = pick(en, hu, lang);
  return (
    <div className={className}>
      <h3 className={`font-heading text-lg font-semibold ${colorClass}`}>{text}</h3>
    </div>
  );
}

/** Hook helper – returns a function that picks EN/HU based on current language. */
export function useBilingual() {
  const { lang } = useLanguage();
  return (en, hu) => pick(en, hu, lang);
}
